module.exports = __webpack_public_path__ + "static/media/payment_bg.0ffaec9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment_bg.png
// module id = 1114
// module chunks = 21